import { Controller, UseFormReturn } from 'react-hook-form';
import { FormEditorForm } from '../../../shared';
import { QBox, QSwitch, QTooltip } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../../displayStrings';

type Props = {
  control: UseFormReturn<FormEditorForm>['control'];
  fieldIndex: number;
  isDisabled?: boolean;
  tooltip?: string;
};

const RequiredSwitch = ({ control, fieldIndex, isDisabled = false, tooltip = '' }: Props) => {
  return (
    <Controller
      name={`fields.${fieldIndex}.mandatory`}
      control={control}
      render={({ field }) => {
        const { value, onChange } = field;

        return (
          <>
            {tooltip ? (
              <QTooltip label={tooltip} placement="top-start">
                <QBox>
                  <QSwitch
                    data-cy={`field-required-${fieldIndex}`}
                    isChecked={value}
                    onChange={onChange}
                    isDisabled={isDisabled}
                  >
                    {DisplayStrings.Required}
                  </QSwitch>
                </QBox>
              </QTooltip>
            ) : (
              <QSwitch
                data-cy={`field-required-${fieldIndex}`}
                isChecked={value}
                onChange={onChange}
                isDisabled={isDisabled}
              >
                {DisplayStrings.Required}
              </QSwitch>
            )}
          </>
        );
      }}
    />
  );
};

export default RequiredSwitch;
